import React, { useEffect, useState } from 'react'
import Select from 'react-select'

import { Link } from 'react-router-dom'
import './footer.scss'
import VO_LOGO from '../../assets/VO_LOGO1.svg'
import TWITTER from '../../assets/Twitter_Icon.svg'
import FACEBOOK from '../../assets/Facebook_Icon.svg'
import INSTAGRAM from '../../assets/Instagram_Icon.svg'
import LINKEDIN from '../../assets/Linkedin_Icon.svg'

import COUNTRY_DATA from "./countryData.json";

const options = [
  { value: 'jamaica', label: 'Jamaica' },
  { value: 'cayman', label: 'Cayman' },
  { value: 'unitedStates', label: 'United States' },
  { value: 'london', label: 'London' },
  { value: 'grenada', label: 'Grenada' },
]

const newCustomers = [
  { text: 'Pricing', link: '/price-plan' },
  { text: 'Request a quote', link: '/contact' },
]

const company = [
  { text: 'Home', link: '/' },
  { text: 'Services', link: '/services' },
  { text: 'About', link: '/about' },
  { text: 'Contact', link: '/contact' },
]


const blogSite = {text: 'Blog', link : 'http://blog.myvirtualoffices.com'};


const Footer = () => {
  let url = 'https://www.creatorsincocoons.com';
  const [country, setCountry] = useState({ label: "jamaica", value: "jamaica" });
  const [currentCountry, setCurrentCountry] = useState({
    country: "",
    phone: "",
    fax: "",
    address: "",
    email: ""

  });

  useEffect(() => {
    const selectedCountry = COUNTRY_DATA.filter((obj) => obj.country.toLocaleLowerCase() === country.value.toLocaleLowerCase())
    setCurrentCountry(selectedCountry[0]);
  }, [country])

  const countryTheme = (theme) => {
    return {
      ...theme,
      colors: {
        ...theme.colors,
        primary25: '#7d77dc',
        primary: '#7d77dc',
      }
    }
  }

  return (
    <>
      <div className="footer">
        <div className="footer__wrapper">
          <div className="footer__wrapper__top">
            <div className="footer__wrapper__top__columns">
              <img className="footer__wrapper__top__columns__logo"
                src={VO_LOGO} alt="" />
              <h3>Get Started</h3>
              <div className="footer__wrapper__top__columns__select">
                <Select
                  onChange={setCountry}
                  theme={countryTheme}
                  className="footer__wrapper__top__columns__select"
                  placeholder="Select Country"
                  options={options}
                  autoFocus
                />
              </div>
              <div className="footer__wrapper__top__columns__contact_info">
                <p className="dfgdfg">Tel: {currentCountry?.phone}</p>
                {currentCountry?.fax && <p>Fax: {currentCountry?.fax}</p>}
                <p>{currentCountry?.address}</p>
                <p>{currentCountry?.email}</p>
              </div>
            </div>
            <div className="footer__wrapper__top__columns">
              {/* <h3 className="tertiary__heading">New Customer</h3> */}
              {newCustomers.map(({ text, link }, index) => (
                <li key={index}>
                  <Link to={link}>{text}</Link>
                </li>
              ))}
              <li><a href="/services#answering-services">Answering Service</a></li>
              <li><a href="/services#corporate-address">Corporate Address</a></li>
              <li><a href="/services#collaborate-assistant">Collaborate Assistant</a></li>
            </div>
            <div className="footer__wrapper__top__columns">
              {/* <h3 className="tertiary__heading">Company</h3> */}
              {company.map(({ text, link }, index) => (
                <li key={index}>
                  <Link to={link}>{text}</Link>
                </li>
              ))}
              <li >
                  <a href={blogSite.link}>{blogSite.text}</a>
                </li>
              {/* <li><a href="https://myvirtualoffices.com/blogs/" target="_blank">Blog</a></li> */}
            </div>
            <div className="footer__wrapper__top__columns">
              {/* <h3 className="tertiary__heading">Already a customer?</h3>
              <Link to="/login">Login</Link> */}
              <div className="footer__wrapper__top__columns__socials">
                <a href="https://twitter.com/virtualofficeja" target="_blank">
                  <img src={TWITTER} alt="" />
                </a>
                <a href="https://www.facebook.com/myvirtualoffices" target="_blank">
                  <img src={FACEBOOK} alt="" />
                </a>
                <a href="https://www.instagram.com/virtualofficejamaica/" target="_blank">
                  <img src={INSTAGRAM} alt="" />
                </a>
                <a href="https://www.linkedin.com/company/virtual-office-jamaica/about/" target="_blank">
                  <img src={LINKEDIN} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="base">
        <p>
          Copyright ©2021, Virtual Enterprise. All Rights Reserved.
                    <Link to="/terms-and-conditions">Terms of Use</Link>|
                    <Link to="/privacy-policy">Privacy Policy</Link>
        </p>
        
      </div>
    </>
  )
}

export default Footer;